/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * How this oral exam is conducted.

``one_to_one`` is the lecturer with one student. ``one_to_n`` is the
examiner agent with every student registered in the time slot.

Deprecated wire value, retired 2026-09-22: ``cohort`` loads as ``one_to_n``.
New responses write ``one_to_n``.
 */
export type OralExamMode = (typeof OralExamMode)[keyof typeof OralExamMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamMode = {
  one_to_one: 'one_to_one',
  one_to_n: 'one_to_n',
} as const;
